import { render, staticRenderFns } from "./SettingDelivery.vue?vue&type=template&id=21f83188&scoped=true&"
import script from "./SettingDelivery.vue?vue&type=script&lang=js&"
export * from "./SettingDelivery.vue?vue&type=script&lang=js&"
import style0 from "./SettingDelivery.vue?vue&type=style&index=0&id=21f83188&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f83188",
  null
  
)

export default component.exports